import React from 'react';
import { Box, Button, Chip, Typography } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import LanguageIcon from '@material-ui/icons/Language';
import OndemandVideoIcon from '@material-ui/icons/OndemandVideo';
import CodeIcon from '@material-ui/icons/Code';
import SlideshowIcon from '@material-ui/icons/Slideshow';
import DescriptionIcon from '@material-ui/icons/Description';
import EmojiEventsIcon from '@material-ui/icons/EmojiEvents';
import StarIcon from '@material-ui/icons/Star';

const parseMarkdown = (text) => {
  if (!text) {
    return '';
  }

  return text
    .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
    .replace(/_(.*?)_/g, '<em>$1</em>')
    .replace(/\*(.*?)\*/g, '<em>$1</em>');
};

const ActionButton = ({ icon: IconComponent, label, href }) => (
  <Button
    component="a"
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    variant="outlined"
    size="small"
    startIcon={<IconComponent fontSize="small" />}
    style={{
      marginTop: 4,
      marginRight: 8,
      textTransform: 'none',
    }}
  >
    {label}
  </Button>
);

// Bold the short name before the colon (e.g. "UIST 2026"), or the whole venue if there is none.
const renderVenue = (venue) => {
  const colonIndex = venue.indexOf(':');
  if (colonIndex === -1) {
    return <strong>{venue}</strong>;
  }

  return (
    <>
      <strong>{venue.slice(0, colonIndex)}</strong>
      {venue.slice(colonIndex)}
    </>
  );
};

const AwardChip =({ icon, label, backgroundColor }) => (
  <Chip
    icon={icon}
    label={label}
    style={{
      backgroundColor,
      marginTop: 4,
      marginRight: 8,
      fontWeight: 600,
    }}
  />
);

const PubItem = (props) => {
  const theme = useTheme();
  const isSmall = props.size === 'small';

  return (
    <Box
      display="flex"
      flexDirection={isSmall ? 'column' : 'row'}
      mb={2}
    >
      {props.thumbnail && (
        <Box
          mr={isSmall ? 0 : 3}
          mb={isSmall ? 2 : 0}
          display="flex"
          justifyContent="center"
          alignContent="center"
          alignItems="center"
        >
          <Box
            component="img"
            src={props.thumbnail}
            alt={props.title}
            style={{
              width: isSmall ? 360 : 240,
              height: 'auto',
              // boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
            }}
          />
        </Box>
      )}
      <Box display="flex" flexDirection="row" flexGrow={1}>
        {!props.thumbnail && (
          <Typography
            style={{
              color: theme.customColors.bullet,
              marginRight: 16,
            }}
          >
            ✦
          </Typography>
        )}
        <Box flexGrow={1}>
          <Typography variant="subtitle1" component="div">
            <strong>
              {props.paper_link ? (
                <a
                  href={props.paper_link}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    color: theme.palette.text.primary,
                    textDecoration: 'none',
                  }}
                >
                  {props.title}
                </a>
              ) : (
                props.title
              )}
            </strong>
          </Typography>
          {props.authors && (
            <Typography
              variant="body2"
              component="div"
              style={{ fontSize: 15, maxWidth: 640 }}
              dangerouslySetInnerHTML={{
                __html: parseMarkdown(props.authors),
              }}
            />
          )}
          {props.venue && (
            <Typography
              variant="body2"
              style={{ color: theme.customColors.active }}
            >
              {renderVenue(props.venue)}
            </Typography>
          )}
          <Box display="flex" flexDirection="column" mt={1}>
            <Box display="flex" flexWrap="wrap">
              {props.pdf && (
                <ActionButton
                  icon={PictureAsPdfIcon}
                  label="PDF"
                  href={props.pdf}
                />
              )}
              {props.website && (
                <ActionButton
                  icon={LanguageIcon}
                  label="Website"
                  href={props.website}
                />
              )}
              {props.video && (
                <ActionButton
                  icon={OndemandVideoIcon}
                  label="Video"
                  href={props.video}
                />
              )}
              {props.code && (
                <ActionButton
                  icon={CodeIcon}
                  label="Code"
                  href={props.code}
                />
              )}
              {props.slides && (
                <ActionButton
                  icon={SlideshowIcon}
                  label="Presentation"
                  href={props.slides}
                />
              )}
              {props.poster && (
                <ActionButton
                  icon={DescriptionIcon}
                  label="Poster"
                  href={props.poster}
                />
              )}
            </Box>
            <Box display="flex" flexWrap="wrap">
              {props.award && (
                <AwardChip
                  icon={<EmojiEventsIcon style={{ color: '#000000' }} />}
                  label={props.award}
                  backgroundColor={theme.customColors.award}
                />
              )}
              {props.award2 && (
                <AwardChip
                  icon={<StarIcon style={{ color: '#000000' }} />}
                  label={props.award2}
                  backgroundColor={theme.customColors.recognition}
                />
              )}
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export { PubItem };
